import { action } from '@reatom/framework'

import { TelegramLocalAuthData, type TelegramAuthData } from '../model'

import { assignTelegramAction } from './reatom-telegram-assign'

import type { TypeHelper } from '@blade/std-lib'
import type { Deeplink } from '@root/entities/deeplinking'

export const handleTelegramAuthDeeplinkAction = action(
  (ctx, deeplink: Deeplink.TelegramAuth) => {
    const tgLocalData = TelegramLocalAuthData.get()

    if (!tgLocalData) {
      return
    }

    if (tgLocalData.action === 'assign') {
      assignTelegramAction(ctx, {
        tgToken: tgLocalData.token,
        authCode: deeplink.code,
      })
      return
    }

    TelegramLocalAuthData.remove()

    if (deeplink.isExists) {
      loginWithTelegramDeeplinkEvent(ctx, {
        userExists: deeplink.isExists,
        code: deeplink.code,
        token: tgLocalData.token,
        action: tgLocalData.action,
      })
    } else {
      registerWithTelegramDeeplinkEvent(ctx, {
        userExists: deeplink.isExists,
        code: deeplink.code,
        token: tgLocalData.token,
        action: tgLocalData.action,
        referralCode: tgLocalData.referralCode,
      })
    }
  },
  'handleTelegramAuthDeeplinkAction',
)

// eslint-disable-next-line @reatom/unit-naming-rule
export const loginWithTelegramDeeplinkEvent = action<
  TypeHelper.OmitKey<TelegramAuthData, 'referralCode'>
>('loginWithTelegramDeeplinkEvent')
// eslint-disable-next-line @reatom/unit-naming-rule
export const registerWithTelegramDeeplinkEvent = action<TelegramAuthData>(
  'registerWithTelegramDeeplinkEvent',
)
